/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mcp_Server_Development_Scope_Detail5Inputs */

const en_svc_mcp_server_development_scope_detail5 = /** @type {(inputs: Svc_Mcp_Server_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which actions agents get, and which stay human-only.`)
};

const ar_svc_mcp_server_development_scope_detail5 = /** @type {(inputs: Svc_Mcp_Server_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أي الإجراءات تحصل عليها الوكلاء وأيها يبقى للبشر فقط.`)
};

const bn_svc_mcp_server_development_scope_detail5 = /** @type {(inputs: Svc_Mcp_Server_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এজেন্টরা কোন অ্যাকশন পাবে আর কোনটা শুধু মানুষের থাকবে।`)
};

const de_svc_mcp_server_development_scope_detail5 = /** @type {(inputs: Svc_Mcp_Server_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Aktionen Agenten erhalten und welche Menschen vorbehalten bleiben.`)
};

const es_svc_mcp_server_development_scope_detail5 = /** @type {(inputs: Svc_Mcp_Server_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué acciones reciben los agentes y cuáles quedan solo para humanos.`)
};

const fr_svc_mcp_server_development_scope_detail5 = /** @type {(inputs: Svc_Mcp_Server_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelles actions les agents reçoivent et lesquelles restent humaines.`)
};

const pt_svc_mcp_server_development_scope_detail5 = /** @type {(inputs: Svc_Mcp_Server_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que ações os agentes recebem e quais ficam só para humanos.`)
};

const zh_svc_mcp_server_development_scope_detail5 = /** @type {(inputs: Svc_Mcp_Server_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`明确助手能拿到哪些动作，哪些只留给人工。`)
};

const tr_svc_mcp_server_development_scope_detail5 = /** @type {(inputs: Svc_Mcp_Server_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajanların hangi eylemleri alacağı ve hangilerinin insana kalacağı.`)
};

const ru_svc_mcp_server_development_scope_detail5 = /** @type {(inputs: Svc_Mcp_Server_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Какие действия получают агенты, а какие остаются только людям.`)
};

const pl_svc_mcp_server_development_scope_detail5 = /** @type {(inputs: Svc_Mcp_Server_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Które akcje dostają agenci, a które zostają tylko dla ludzi.`)
};

/**
* | output |
* | --- |
* | "Which actions agents get, and which stay human-only." |
*
* @param {Svc_Mcp_Server_Development_Scope_Detail5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mcp_server_development_scope_detail5 = /** @type {((inputs?: Svc_Mcp_Server_Development_Scope_Detail5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mcp_Server_Development_Scope_Detail5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mcp_server_development_scope_detail5(inputs)
	if (locale === "bn") return bn_svc_mcp_server_development_scope_detail5(inputs)
	if (locale === "de") return de_svc_mcp_server_development_scope_detail5(inputs)
	if (locale === "es") return es_svc_mcp_server_development_scope_detail5(inputs)
	if (locale === "fr") return fr_svc_mcp_server_development_scope_detail5(inputs)
	if (locale === "pt") return pt_svc_mcp_server_development_scope_detail5(inputs)
	if (locale === "zh") return zh_svc_mcp_server_development_scope_detail5(inputs)
	if (locale === "tr") return tr_svc_mcp_server_development_scope_detail5(inputs)
	if (locale === "ru") return ru_svc_mcp_server_development_scope_detail5(inputs)
	if (locale === "pl") return pl_svc_mcp_server_development_scope_detail5(inputs)
	return en_svc_mcp_server_development_scope_detail5(inputs)
});
export { svc_mcp_server_development_scope_detail5 as "svc_mcp-server-development_SCOPE_detail" }